import React, { useEffect, useMemo, useState } from "react";
import sethoscopeIcon from "../../assets/cards/maki_doctor.svg";
import calenderIcon from "../../assets/cards/uil_notes.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import Created from "../../assets/landingscreen/Pending.svg";
import CompletedIcon from "../../assets/landingscreen/CompletedIcon.svg";
import crossIcon from "../../assets/landingscreen/CloseIcon.svg";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Paymentsmodal from "../modals/payments";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import cancelledDesk from "../../../src/assets/Signin/FrontCancel.svg";
import DropdownMenu from "../modals/menu";
import { openOrdersFromDashboard } from "../dashboardSearch";
import LiveOrdersSlot from "../../components/OrderReview/LiveOrdersSlot";
import VisitStatusUpdate from "../modals/VisitStatusUpdate";
import ImagingModal from "../modals/imagingmodal";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import {
  alertIcon,
  ChartIcon,
  closeIcon,
  COMPLETEDIcon,
  CROSSIcon,
  listFileIcon,
  actionDollarIconbig,
  NotesIcon,
  OrderIcon,
  actionDropDownCalenderIconbig,
  actionDropDownChatIconBig,
  actionDropDownSchedulerIconBig,
  mobileicon,
  mobileapp,
  cancelfrontdeskicon,
  vitalsiconbig,
  intakeiconbig,
  RpmIcon,
  mobileiconnew,
  cancelfrontdeskicondashboard,
  bluesethescope,
} from "../modals/svgs";
import { actionDropDownCalenderIcon, filterIcon } from "../modals/svgs";
import AssignRoomModal from "../modals/assignroommodal";
import VisitStatusModal from "../modals/visitstatusmodal";
import PurposeOfVisitModal from "../modals/purposeofvisitmodal";
import ProviderModal from "../modals/Providermodal";
import AddNotesModal from "../modals/notemodal";
import VisitTimeline from "./visittimeline";
import CoveragePill from "./coveragepill";
import AthenaCheckinChip from "./athenaCheckinChip";
import NoInsuranceChip from "./insuranceWarningChip";
import { isCoverageVerified } from "./coveragestatus";
import {
  isCoverageNote,
  parseStamp,
  compareCoverageNotes,
  parseJourney,
  minutesBetween,
  followUpAppointment,
  isPastClinicDay,
  isStampOnDay,
  clinicStamp,
} from "./visitflow";
import {
  isSyntheticOrder,
  isActionableOrder,
  visitRowValues,
  orderBadge,
} from "./visitrow";
import { rpmTag } from "./rpmtag";
import CoverageNoteModal from "../modals/coveragenotemodal";
import api from "../../api/api";
import "./patientcard.css";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import TasksModal from "../../tasks/Modals/TasksModal";
import { calendericonblue } from "../../utils/svgs/svgcode";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CCMIcon, RPMIcon } from "../landingsvgs";
import { pendingIcon } from "../../orders/tabs/svg";
import { set } from "date-fns";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { eventBus } from "../../utils/eventBus";
import { clearChartStartTab, requestChartStartTab } from "../../utils/chartStartTab";
import ConfirmFrontdesk from "../../signin/popups/ConfirmFrontdesk";
import AllAppointmentsModal from "./allappointmentmodal";
import QualityRiskApptsModal from "../modals/QualityRiskApptsModal";
import { cardActionShown, cardBlockShown, cardDefaultPins, cardOrderNotes, getPracticeId, patientPhotoUrl } from "../../config/practice";
import OrderNotes from "./OrderNotes";
import { cardAmountDue } from "../modals/osaPayments";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import { practiceFeatures } from "../../config/practice";
import { useSendFormsWizard } from "../../forms/staff/launch";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import { useStaffFormFill } from "../../forms/internal/launch";

dayjs.extend(customParseFormat);
/* Patient photo with an initials fallback. The photo flag is only maintained by
   the prod cron (dev rows carry ''), so always try the public photo store and
   let onError fall back - same approach as NewDashboard's Avatar. */
const PatientAvatar = ({ row, name }) => {
  const [broken, setBroken] = useState(false);
  const url = patientPhotoUrl(row.patientid);
  if (!broken) {
    return (
      <img
        className="photo"
        alt={name}
        src={url}
        onError={() => setBroken(true)}
      />
    );
  }
  const initials = String(name || "?")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return <div className="photo initials">{initials}</div>;
};

// Covered-service chips. Every covered service renders identically, so only the
// display name varies. Tokens arrive uppercase and case-inconsistent across eras;
// anything unlisted falls back to Title Case rather than a different chip.
const COVERAGE_LABEL = {
  VISIT: "Visit",
  INJ: "Injections",
  INJECTIONS: "Injections",
  EKG: "EKG",
  SLEEP: "Sleep Study",
  SLEEPSTUDY: "Sleep Study",
  ECHO: "Echo",
  RPM: "RPM",
  LABS: "Labs",
  ULTRASOUND: "Ultrasound",
};
const coverageLabel = (plan) => {
  const key = String(plan || "").trim().toUpperCase();
  return (
    COVERAGE_LABEL[key] || key.charAt(0) + key.slice(1).toLowerCase()
  );
};

/* Drawn chevron for the Notes and "Show all orders" disclosures (was the
   "&#8964;" glyph, which rendered thin and off-centre). Points down; the CSS
   flips it when open. */
const DisclosureChevron = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const ExpandedView = ({
  selectedCard,
  setFetchedData,
  setSelectedCard,
  fetchUpdateFrontDesk,
  rpmvalues,
  updateeyeicon,
  searchTerm,
  setChat,
  fetchedData,
  dob,
  modalopen,
  insertdata,
  paymentdetails,
  alldata,
  markAsComplete,
  markAscancel,
  handleconfirmScheduleClick,
  scheduleStates,
  setIsStatusNotesPopUp,
  setIsOrdersOverlay,
  fetchpcarddata,
  data,
  onUpdateVisitStatus,
  onUpdateRoom,
  setIsRoomNoOverlay,
  setToastSeverity,
  setToastMessage,
  setOpenToast,
  selectedOrder,
  setSelectedOrder,
  refreshDashboard,
  handleschedular,
}) => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [VisitStatus, setVisitStatus] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // On the All tab (filter.tab null) a cancelled visit is greyed out; on a
  // status tab it keeps its normal look.
  const dimCancelled = !useSelector((state) => state.filter.tab);
  const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen,
  );
  const location = useLocation();
  const [openAllApptsModal, setOpenAllApptsModal] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [ordersExpanded, setOrdersExpanded] = useState(false);

  const currentDate = useSelector((state) => state.filter.currentDate);

  const [isQuickOpen, setIsQuickOpen] = useState(false);
  const userConfig = useSelector((state) => state.userconfig);
  // Form Wizard: "Send Forms" (action id 10) opens it for this patient/visit.
  const [openSendForms, sendFormsWizard] = useSendFormsWizard();
  // Internal staff forms: "Staff Form" (action id 11) fills one for this patient/visit.
  const [openStaffForm, staffFormFill] = useStaffFormFill();
  const [visitModalOpen, setVisitModalOpen] = useState(false);
  const [roomModalOpen, setRoomModalOpen] = useState(false);
  const [purposeModalOpen, setPurposeModalOpen] = useState(false);
  const [purposeInitialIndex, setPurposeInitialIndex] = useState(0);
  const [localPurpose, setLocalPurpose] = useState("");
  const [providerModalOpen, setProviderModalOpen] = useState(false);
  const [localProvider, setLocalProvider] = useState(
    data.linked_provider || "",
  );
  const [frontDesk, setFrontDesk] = useState("");
  const [frontdeskModal, setfrontdeskModal] = useState(false);
  const [scheduleConfirmationOpen, setScheduleConfirmationOpen] =
    useState(false);
  const [cachedPins, setCachedPins] = useState([]);
  console.log(data, "daaaa");
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [quartersModalOpen, setQuartersModalOpen] = useState(false);
  const [noteDraft, setNoteDraft] = useState({
    assignee: "Provider",
    message: "",
  });
  const [totalOrders, setTotalOrders] = useState([]);
  const [checkingOut, setCheckingOut] = useState(false);
  const [coverageModalOpen, setCoverageModalOpen] = useState(false);
  const percentage = 100; // Set your percentage value here
  const navigate = useNavigate();
  // Styles for the circular progress bar and small circle with percentage text
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };
  // const reduxDate = useSelector((state) => state.filter.currentDate);
  // // const startDateObj = new Date(data.startdate);
  // const startDateObj = dayjs(data.startdate, "YYYY-MM-DD HH:mm:ss");
  // console.log(data.startdate,'starttttt')
  // const dtObj = reduxDate;
  // const year = startDateObj.getFullYear();
  // const month = String(startDateObj.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  // const day = String(startDateObj.getDate()).padStart(2, "0");
  const viewMode = "tile";
  // const formattedDate = `${year}-${month}-${day}`;
  // const isSameDate = formattedDate === dtObj;
  const reduxDate = useSelector((state) => state.filter.currentDate);

  // start date from API
  const startDateObj = dayjs(data.startdate, "YYYY-MM-DD HH:mm:ss");

  // redux date (assume format YYYY-MM-DD)
  const dtObj = dayjs(reduxDate, "YYYY-MM-DD");

  // ✅ timezone-safe same day check
  const isSameDate = startDateObj.isSame(dtObj, "day");
  const angle = percentage * 3.6;
  const radians = (angle - 90) * (Math.PI / 180);
  const radius = 45; // Increased radius
  const smallCircleOffset = 10; // Adjusted offset for larger size
  const smallCircleStyle = {
    position: "absolute",
    top: `${50 + radius * Math.sin(radians) - smallCircleOffset}px`,
    left: `${56 + radius * Math.cos(radians) - smallCircleOffset}px`,
    width: "28px", // Increased size of the small circle
    height: "28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const openNoteModal = () => setNoteModalOpen(true);

  const openPaymentModal = () => {
    setIsPaymentModalOpen(true); // Open the payment modal
  };

  // Function to close the Payment modal
  const closePaymentModal = () => {
    setIsPaymentModalOpen(false); // Close the payment modal
  };
  const GREEN = "58D68D";
  const RED = "F3082C";
  const YELLOW = "F9E79F";

  const handleFrontDeskToggle = () => {
    const newStatus = frontDesk === "Y" ? "N" : "Y";
    setFrontDesk(newStatus);
    fetchUpdateFrontDesk({ frontDesk: newStatus, data: data });
  };
  const getPatientColor = () => {
    const raw = data?.deductiblemet;
    if (!raw) return "none";

    const color = String(raw).trim().replace("#", "").toUpperCase();

    if (color === GREEN) return "green";
    if (color === RED || color === YELLOW) return "red";

    return "none";
  };

  const isVitamin = (order) => order?.ordertype?.toLowerCase() === "vitamin";

  const shouldShowPrice = (order) => {
    const color = getPatientColor();

    if (color === "red") return true;

    if (color === "green") return isVitamin(order);

    return isVitamin(order);
  };
  const getSafeNumber = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };

  const deductibleAmt = getSafeNumber(data?.deductibleamt);
  const selfPay = getSafeNumber(data?.selfpay);
  const accountBalance = getSafeNumber(data?.acctbalance);
  const copayAmt = getSafeNumber(data?.copay);

  const latestRpm = useMemo(() => {
    if (!Array.isArray(rpmvalues)) return null;

    const patientRecords = rpmvalues
      .filter((r) => String(r.patientid) === String(data?.patientid))
      .sort((a, b) => new Date(b.datetime) - new Date(a.datetime));

    return patientRecords.length ? patientRecords[0] : null;
  }, [rpmvalues, data?.patientid]);

  // Green "RPM" only while readings are coming in; enrolled patients with none
  // in 30 days get a muted "RPM · inactive" (see rpmtag.js).
  const rpm = cardBlockShown("rpm") ? rpmTag(data) : null;
  // Risk adjustment / quality measure flag (gated per practice; 7825: none).
  const qualityRisk = cardBlockShown("quality") ? data?.quality_risk_metrics : undefined;

  const closeNoteModal = () => setNoteModalOpen(false);

  const closeVisitStatus = () => {
    setVisitStatus(false);
  };
  const formatTime = (time) => {
    if (!time) return "-";

    const [hourStr, minute] = time.split(":");
    let hour = Number(hourStr);

    const period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convert 0 → 12

    return `${hour}:${minute} ${period}`;
  };
  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
    setScheduleConfirmationOpen(true); // Open the confirmation modal
  };
  const getCoveredPlans = (data) => {
    try {
      const raw = data?.appointment_specific?.insuranceCoveredPlan;
      // Normalize once: stored tokens are case-inconsistent across eras
      // ("INJECTIONS" legacy vs "Injections"/"Labs" from the current modal
      // list), and every comparison below is exact-match — so covered labs/
      // ultrasounds still billed (Gowtham, QA 2026-08-31).
      return (raw ? JSON.parse(raw) : []).map((p) => String(p).trim().toUpperCase());
    } catch {
      return [];
    }
  };
  const isOrderCovered = (orderName, coveredPlans = [], ordertype) => {
    if (!orderName) return false;

    const name = orderName.trim().toUpperCase();
    const type = (ordertype || "").trim().toUpperCase();
    // coveredPlans is already normalized to UPPERCASE by getCoveredPlans.
    if (type.startsWith("INJECTION")) return coveredPlans.includes("INJECTIONS");
    if (type.startsWith("LAB")) return coveredPlans.includes("LABS");
    if (name === "ECG/EKG" || name === "EKG") return coveredPlans.includes("EKG");
    if (name.includes("SLEEP STUDY")) return coveredPlans.includes("SLEEP STUDY");
    if (name === "ECHO") return coveredPlans.includes("ECHO");
    if (name.startsWith("US ") || name.startsWith("US-") ||
        name.includes("ULTRASOUND") || name.includes("SONOGRAM"))
      return coveredPlans.includes("ULTRASOUND");

    return coveredPlans.includes(name);
  };
  const calculateCostEstimate = () => {
    const orders = data?.orders || [];
    const coveredPlans = getCoveredPlans(data);
    const color = getPatientColor();

    // green → no estimate
    if (color === "green") return 0;

    let total = 0;

    orders.forEach((order) => {
      if (!shouldShowPrice(order)) return;

      const matched = paymentdetails.find(
        (p) => p.content === order?.ordername,
      );
      if (!matched) return;

      const isCoveredType = coveredPlans.includes(
        (order?.ordertype || "").trim().toUpperCase()
      );
      if (isCoveredType) return;
      const isCovered = isOrderCovered(order?.ordername, coveredPlans, order?.ordertype);
      if (isCovered) return;

      const amount = isVitamin(order)
        ? Number(matched.selfpay_cost || 0)
        : Number(matched.insurance_cost || 0);

      total += amount;
    });

    return total;
  };

  // Map order code to the insurance plan
  function mapOrderCodeToPlan(orderName, coveredPlans) {
    const orderNameUpper = orderName.trim().toUpperCase();
    if (orderNameUpper === "ECG/EKG" && coveredPlans.includes("EKG")) return true;
    if (orderNameUpper.includes("SLEEP STUDY") && coveredPlans.includes("SLEEP STUDY")) return true;
    if (orderNameUpper === "ECHO" && coveredPlans.includes("ECHO")) return true;
    if ((orderNameUpper.startsWith("US ") || orderNameUpper.startsWith("US-") ||
         orderNameUpper.includes("ULTRASOUND") || orderNameUpper.includes("SONOGRAM")) &&
        coveredPlans.includes("ULTRASOUND")) return true;
    return false;
  }

  const patientColor = getPatientColor();

  let costEstimate = 0;

  // 🟡 If yellow → take from percentage.Amount
  if (data?.deductiblemet?.toUpperCase() === YELLOW) {
    costEstimate = Number(data?.percentage?.Amount || 0);
  }
  // 🟢 green → 0
  else if (patientColor === "green") {
    costEstimate = 0;
  }
  // 🔴 red → existing calculation
  else {
    costEstimate = calculateCostEstimate();
  }

  // const finalCopayTotal =
  //   costEstimate +
  //   // deductibleAmt +
  //   selfPay +
  //   accountBalance+
  //+copayAmt

  // const totalDue = Number(costEstimate || 0) + Number(selfPay || 0);

  // const credits =
  //   Number(accountBalance || 0) +
  //   Number(copayAmt || 0) +
  //   Number(data?.paidamount || 0);

  // const finalCopayTotal = Math.max(0, totalDue - credits);
  const careCopayTotal =
    costEstimate +
    // deductibleAmt +
    selfPay +
    accountBalance +
    copayAmt;
  // 7825 (OSA): the deductible and the coinsurance dollars are due too.
  const finalCopayTotal = cardAmountDue({
    careTotal: careCopayTotal,
    row: data,
    coinsuranceInEstimate: data?.deductiblemet?.toUpperCase() === YELLOW,
  });
  const finalformattedTotalcopay =
    Number(finalCopayTotal) % 1 === 0
      ? Number(finalCopayTotal)
      : Number(finalCopayTotal).toFixed(2);

  //   console.log("Patient  data:4808", {
  //   finalformattedTotalcopay,
  //   costEstimate,
  //   selfPay,
  //   accountBalance,
  //   copayAmt,
  //   paidamou0nt: data?.paidamount
  // });
  //     useEffect(()=>{
  //     if (data?.patientid == 4808) {
  //   console.log("Patient  data:4808", {
  //     finalformattedTotalcopay,
  //     costEstimate,
  //     selfPay,
  //     accountBalance,
  //     copayAmt,
  //     paidamount: data?.paidamount
  //   });
  // }
  //     },[data,])

  const statusChipClasses = (label, active) => {
    // ✅ inactive → always default
    if (!active) return "bg-[#D1E1FF] text-[#004867]";

    if (label === "Ready for Triage") return "border-[#A7F3D0] text-[#065F46]";
    if (label === "Cancelled") return "border-[#FECACA] text-[#991B1B]";
    if (label === "In-Office - Confirmed")
      return "border-[#E9D5FF] text-[#581C87]";
    if (label === "Ready for Representative")
      return "border-[#FEF08A] text-[#854D0E]";
    if (label === "Processing") return "border-[#E2E8F0] text-[#1E293B]";
    if (label === "Walk-in") return "border-[#DDD6FE] text-[#4C1D95]";
    if (["Injections", "Labs"].includes(label))
      return "border-[#FED7AA] text-[#9A3412]";
    if (label === "Checked Out") return "border-[#FDA4AF] text-[#9F1239]";
    if (label === "Ready for Provider")
      return "border-[#FBCFE8] text-[#9D174D]";
    if (label === "Ready for Checkout")
      return "border-[#C7D2FE] text-[#312E81]";
    if (label === "Ready for Nurse") return "border-[#A5F3FC] text-[#155E75]";
    if (label === "No Show") return "border-[#D1D5DB] text-[#1F2937]";
    if (label === "Active") return "border-[#BBF7D0] text-[#166534]";
    if (label === "Rescheduled") return "border-[#BFDBFE] text-[#1E40AF]";

    // ✅ ANY NOT MATCH → default
    return "bg-[#D1E1FF] text-[#004867]";
  };

  /* hideHeader: the card's Orders disclosure already renders the label and the
     count in its <summary>, and owns the scroll box, so the inner copy would
     double up. */
  const CardBox = ({ data, paymentdetails, hideHeader }) => {
    // The coverage note repeats the coverage chips; it opens from their "i".
    const orders = (data.orders || []).filter((o) => !isCoverageNote(o));

    // Open rows while any real order is open, else every row, greyed. The
    // dashboard's display-only visit row (synthetic) is listed and counted
    // but never keeps the badge active (visitrow.js).
    const { count: listedCount, allInactive } = orderBadge(orders);

    return (
      <button
        // The whole list opens the quick view, but it reads as content, not a
        // button, so it opts out of the global hover tint (no-hover-tint).
        className="no-hover-tint w-full h-full  items-start focus:outline-none focus:ring-0   focus:ring-offset-0 focus-visible:outline-none"
        onClick={() => {
          // The quick view acts on real orders; a box holding only the
          // display-only visit row has nothing to open.
          if (!orders.some(isActionableOrder)) return;
          setTotalOrders(orders);
          setIsQuickOpen(true);
        }}
      >
        {!hideHeader && (
          <div className="flex items-center gap-2 mb-1">
            <span className="text-[#6B7280] font-[600] font-inter text-[14px]">
              Orders/Tasks
            </span>
            <span
              className={`inline-flex items-center justify-center h-[26px] w-[26px] rounded-full text-[13px] font-bold ${
                allInactive
                  ? "bg-[#E5E7EB] text-[#6B7280]"
                  : listedCount > 0
                    ? "bg-[#e57f5c] text-white"
                    : "bg-[#E5E7EB] text-[#6B7280]"
              }`}
            >
              {listedCount}
            </span>
          </div>
        )}
        <div
          className={
            hideHeader
              ? "pr-1"
              : "h-[240px] pr-3 overflow-y-auto card_custom-scrollbar"
          }
        >
          {orders.length === 0 ? (
            <div className="flex flex-col justify-center items-center h-full text-center py-8">
              <div className="mb-3">{listFileIcon}</div>

              <p className="text-[#6B7280] text-sm font-medium font-inter mb-1">
                No orders yet
              </p>

              <p className="text-[#9CA3AF] text-xs font-normal font-inter">
                Orders will appear here when added
              </p>
            </div>
          ) : (
            <div className="flex flex-col">
              {/* <span className="mb-1 text-xs font-semibold text-left text-[#364153] uppercase">
                Visit Details
              </span> */}

              {[...orders]
                .filter((order) => {
                  const status = String(order?.status).toUpperCase();
                  if (status === "CANCELLEDTASK" && order?.is_hide === "Y") {
                    return false; // don't show
                  }
                  return true;
                })
                .sort((a, b) => {
                  const getOrderRank = (status) => {
                    const s = String(status).toUpperCase();
                    if (s === "COMPLETED") return 2; // middle
                    if (s === "PENDING" || s === "CANCELLEDTASK") return 3; // last
                    return 1; // normal first
                  };
                  const rankDiff = getOrderRank(a.status) - getOrderRank(b.status);
                  if (rankDiff !== 0) return rankDiff;
                  // Visit leads its status group: pending orders stay above it,
                  // but it tops the completed list (request 2026-09-22).
                  const visitFirst = (o) =>
                    String(o?.ordertype || "").trim().toUpperCase() === "VISIT" ? 0 : 1;
                  return visitFirst(a) - visitFirst(b);
                })
                .map((order, idx) => {
                  const rawType = (order?.ordertype || "").trim();
                  const isVisit = rawType.toUpperCase() === "VISIT";
                  const isNotes = rawType.toLowerCase() === "notes";
                  // Display-only visit row from the level of visit (no
                  // orders_master row, id null): no status pill, no hide,
                  // and a click on it does nothing.
                  const synthetic = isSyntheticOrder(order);
                  const rowKey = order?.id ?? `${synthetic ? "synthetic" : "row"}-${idx}`;

                  const typeLabel =
                    rawType.charAt(0).toUpperCase() +
                    rawType.slice(1).toLowerCase();

                  const name = order?.ordername || "-";
                  const MAX_CHARS = 35;
                  const clipped =
                    name.length > MAX_CHARS
                      ? `${name.slice(0, MAX_CHARS)}…`
                      : name;

                  const renderRow = (label, value, key, source = null) => {
                    const status = String(order?.status).toUpperCase();
                    const isCompleted = status === "COMPLETED";
                    const isCancelled = status === "CANCELLEDTASK";
                    /* Dim only when the user opted into seeing finished
                       tasks greyed out (config.tasks_completed), as before. */
                    const dimmed =
                      (isCompleted || isCancelled) &&
                      userConfig?.config?.tasks_completed;

                    const orderPrice = (() => {
                      const matchedPatient = paymentdetails.find(
                        (p) => p.content === order?.ordername,
                      );
                      if (
                        !matchedPatient ||
                        !shouldShowPrice(order) ||
                        !userConfig?.config?.show_prices
                      ) {
                        return null;
                      }

                      const insCoveredPlan = getCoveredPlans(data) || [];
                      const normalizedPlans = insCoveredPlan.map((p) =>
                        String(p).toUpperCase(),
                      );
                      const orderType = String(
                        order?.ordertype || "",
                      ).toUpperCase();

                      // Vitamin → always self pay
                      if (orderType === "VITAMIN") {
                        return Math.floor(matchedPatient.selfpay_cost || 0);
                      }

                      const deductible = String(
                        data?.deductiblemet || "",
                      ).toUpperCase();

                      // 🟡 YELLOW → insurance cost
                      if (
                        deductible === "F9E79F" &&
                        matchedPatient.insurance_cost > 0
                      ) {
                        return Math.floor(matchedPatient.insurance_cost);
                      }

                      // 🔴 RED → self pay unless the plan covers it
                      if (
                        deductible === "F3082C" &&
                        matchedPatient.selfpay_cost > 0
                      ) {
                        const isCovered =
                          mapOrderCodeToPlan(
                            order?.ordername,
                            normalizedPlans,
                          ) || normalizedPlans.includes(orderType);
                        if (isCovered) return null;
                        return Math.floor(matchedPatient.selfpay_cost);
                      }

                      return Math.floor(matchedPatient.insurance_cost || 0);
                    })();

                    return (
                      <div
                        key={key}
                        className={`order-item${isVisit ? " visit-order" : ""}${
                          synthetic ? " synthetic" : ""
                        }${
                          dimmed
                            ? isCancelled
                              ? " dim cancelled"
                              : " dim"
                            : ""
                        }`}
                        title={
                          synthetic
                            ? `${source?.title || "Level of visit"} (no visit order)`
                            : undefined
                        }
                        onClick={
                          synthetic ? (e) => e.stopPropagation() : undefined
                        }
                      >
                        {isVisit ? (
                          <span className="oicon visit-icon" aria-hidden="true">
                            V
                          </span>
                        ) : (
                          <span
                            className={`oicon ${
                              isCompleted ? "ok" : isCancelled ? "bad" : "flask"
                            }`}
                            aria-hidden="true"
                          >
                            {isCompleted ? (
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2.6"
                              >
                                <polyline points="20 6 9 17 4 12" />
                              </svg>
                            ) : isCancelled ? (
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2.6"
                              >
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                              </svg>
                            ) : (
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2.1"
                              >
                                <path d="M7 3h10" />
                                <path d="M7 21h10" />
                                <path d="M8 3c0 4.5 4 5.5 4 9s-4 4.5-4 9" />
                                <path d="M16 3c0 4.5-4 5.5-4 9s4 4.5 4 9" />
                              </svg>
                            )}
                          </span>
                        )}

                        <div className="o-main">
                          <div className="o-kind">
                            {label}
                            {isNotes && order?.user_role
                              ? ` ${order.user_role}`
                              : ""}
                            {source && (
                              <span
                                className={`lov-src ${source.kind}`}
                                title={source.title}
                              >
                                {source.text}
                              </span>
                            )}
                          </div>
                          <div className="o-name" title={value}>
                            {value || "-"}
                          </div>
                        </div>

                        {!synthetic && (
                          <span
                            className={`o-status ${
                              order?.schedule === "t" ? "sched" : "today"
                            }`}
                          >
                            {order?.schedule === "t" ? "Schedule" : "Today"}
                          </span>
                        )}

                        {orderPrice !== null && (
                          <span className="o-price">${orderPrice}</span>
                        )}

                        {isCancelled &&
                          !synthetic &&
                          String(order?.is_hide).toUpperCase() === "N" && (
                            <FontAwesomeIcon
                              icon={faEyeSlash}
                              className="text-[#9CA3AF] text-[14px] cursor-pointer"
                              title="Hidden order"
                              onClick={(e) => {
                                e.stopPropagation(); // prevents the quick modal
                                updateeyeicon(order);
                              }}
                            />
                          )}
                      </div>
                    );
                  };

                  // For non-VISIT → show normal row
                  if (!isVisit) {
                    return renderRow(typeLabel, clipped, rowKey);
                  }

                  // For VISIT → the level (with who set it: AI or Provider)
                  // and the wellness slot, each only if it exists.
                  return (
                    <React.Fragment key={rowKey}>
                      {visitRowValues(order).map((v) =>
                        renderRow("Visit", v.value, `${rowKey}-${v.slot}`, v.source),
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
          )}
        </div>
      </button>
    );
  };

  const allActionsAll = [
    {
      id: 1,
      key: "Chart",
      icon: ChartIcon,
      label: "Charts",
      onClick: () => { clearChartStartTab(); modalopen(data.id); },
      visible: homescreenprev.includes("Chart"),
    },
    {
      id: 2,
      key: "Order",
      icon: OrderIcon,
      label: "Orders",
      onClick: () => {
        if (!isSameDate) {
          setToastMessage("Please schedule an appointment");
          setToastSeverity("info");
          setOpenToast(true);
          return;
        }
        openOrdersFromDashboard(navigate, location, data, searchTerm);
      },
      visible: homescreenprev.includes("Order"),
    },
    {
      id: 3,
      key: "Notes",
      icon: NotesIcon,
      label: "Notes",
      onClick: openNoteModal,
      visible: homescreenprev.includes("Notes"),
    },
    {
      id: 4,
      key: "Take Payment",
      icon: actionDollarIconbig,
      label: "Payments",
      onClick: openPaymentModal,
      visible: homescreenprev.includes("Take Payment"),
    },
    {
      id: 5,
      key: "Imaging",
      icon: actionDropDownCalenderIconbig,
      label: "Imaging",
      onClick: () => insertdata(data),
      visible: true,
    },
    {
      id: 6,
      key: "Chat",
      icon: actionDropDownChatIconBig,
      label: "Chat",
      onClick: () => {
        setSelectedCard(data);
        setChat(true);
      },
      visible: true,
    },
    {
      id: 7,
      key: "Scheduler",
      icon: actionDropDownSchedulerIconBig,
      label: "Scheduler",
      onClick: () => {
        setSelectedCard(data);
        handleschedular(data);
      },
      visible: true,
    },
    {
      id: 8,
      key: "Vitals",
      icon: vitalsiconbig,
      label: "Vitals",
      onClick: () => {
        requestChartStartTab(data.patientid, 3); // opens on Vitals (utils/chartStartTab.js)
        modalopen(data.id);

        setTimeout(() => {
          eventBus.emit("navigateToPriorVitals", { tab: 3, internalTab: 1 });
        }, 50); // or 100ms if needed
      },
      visible: true,
    },
    {
      id: 9,
      key: "Intake",
      icon: intakeiconbig,
      label: "Intake",
      onClick: () => {
        requestChartStartTab(data.patientid, 3); // opens on Vitals (utils/chartStartTab.js)
        modalopen(data.id);

        setTimeout(() => {
          eventBus.emit("navigateToPriorVitals", { tab: 3, internalTab: 0 });
        }, 50); // or 100ms if needed
      },
      visible: homescreenprev.includes("Intake"),
    },
    // Form Wizard (practiceFeatures().formWizard): never a default pin.
    ...(practiceFeatures().formWizard
      ? [
          {
            id: 10,
            key: "Send Forms",
            icon: <PostAddOutlinedIcon sx={{ fontSize: 22 }} />,
            label: "Send Forms",
            onClick: () => openSendForms(data, { dob }),
            visible: practiceFeatures().formWizard,
          },
        ]
      : []),
    // Internal staff forms (practiceFeatures().staffForms): never a default pin.
    ...(practiceFeatures().staffForms
      ? [
          {
            id: 11,
            key: "Staff Form",
            icon: <NoteAltOutlinedIcon sx={{ fontSize: 22 }} />,
            label: "Staff Form",
            onClick: () => openStaffForm(data, { dob }),
            visible: practiceFeatures().staffForms,
          },
        ]
      : []),
  ];
  // The practice's card action allowlist (7825: Notes, Take Payment,
  // Scheduler, Intake; 9928: every action).
  const allActions = allActionsAll.filter((a) => cardActionShown(a.key));
  const latestAppointment = (() => {
    if (!Array.isArray(data?.allappts)) return null;

    const grouped = {};

    data.allappts.forEach((appt) => {
      const date = dayjs(appt.startdate).format("YYYY-MM-DD");

      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(appt);
    });

    const result = Object.values(grouped).map((appointments) => {
      const valid = appointments.filter(
        (a) => a.visit_confirmation !== "Cancelled",
      );

      const list = valid.length ? valid : appointments;

      return list.sort(
        (a, b) => new Date(b.startdate) - new Date(a.startdate),
      )[0];
    });

    return result[0] || null; // 👈 THIS LINE
  })();

  useEffect(() => {
    if (
      Array.isArray(userConfig?.config?.dash_pins) &&
      userConfig.config.dash_pins.length
    ) {
      setCachedPins(userConfig.config.dash_pins);
    }
  }, [userConfig?.config?.dash_pins]);

  const pinnedActions = useMemo(() => {
    const pins = userConfig?.config?.dash_pins;

    let activePins = Array.isArray(pins) && pins.length ? pins : cachedPins;
    // A practice with its own default pins (7825): pins its allowlist
    // removed don't count, and once that leaves fewer than the pin menu's
    // minimum (3) the defaults show -- pins [Chart, Orders] or C-HIM's
    // new-user seed [Intake, Vitals, Chart, Order] (Intake alone) included.
    if (cardDefaultPins() && activePins && activePins.length) {
      activePins = activePins.filter((id) => allActions.some((act) => act.id === id));
      if (activePins.length < Math.min(3, cardDefaultPins().length)) activePins = null;
    }

    // No pins configured → default menu: Chart, Orders, Notes (user 2026-09-16).
    // (A practice with its own default pins: those, by key; 7825 leads
    // with Intake, its way into the chart.)
    const effectivePins =
      activePins && activePins.length
        ? activePins
        : cardDefaultPins()
        ? cardDefaultPins().map((key) => allActions.find((act) => act.key === key)?.id).filter(Boolean).reverse()
        : [1, 2, 3];

    if (!effectivePins.length) return [];

    return effectivePins
      .map((id) => allActions.find((act) => act.id === id))
      .filter(Boolean)
      .reverse();
    // `data` MUST be a dep: allActions' onClicks close over it, and when the
    // provider-filter chips change which row this card shows, a memo without
    // it kept serving the PREVIOUS row's handlers — Chart opened the patient
    // from the unfiltered list (user report 2026-09-02).
  }, [userConfig?.config?.dash_pins, cachedPins, homescreenprev, data]);
  const allAppts = Array.isArray(data?.allappts) ? data.allappts : [];
  const MAX_VISIBLE = 2;
  const visibleAppts = allAppts.slice(0, MAX_VISIBLE);
  const visibleAppt = allAppts;
  const remainingCount = Math.max(allAppts.length - MAX_VISIBLE, 0);
  const cardHeight = useMemo(() => {
    const BASE_HEIGHT = 320;
    const ACTION_HEIGHT = 65;
    const MAX_VISIBLE = 3;

    const extraPinned =
      pinnedActions.length > MAX_VISIBLE
        ? pinnedActions.length - MAX_VISIBLE
        : 0;
    const cancelledExtra =
      latestAppointment?.visit_confirmation === "Cancelled" ? 5 : 0;
    return BASE_HEIGHT + extraPinned * ACTION_HEIGHT + cancelledExtra;
  }, [pinnedActions]);

  /* Order count for the disclosure badge. Mirrors CardBox's own rule: while any
     order is still open we count only those, and once everything is
     completed/cancelled we show the full total rather than a bare 0. */
  const roomLabel = (data?.room_no || "-").replace(
    /^waiting room$/i,
    "Waiting"
  );

  // Post-checkout card state (request 2026-09-22): the room chip becomes a
  // static "Checked Out" (no assign). The Next Appointment panel below shows
  // whenever the backend sent one, checked out or not, next to the timeline.
  const isCheckedOut =
    String(data?.visit_confirmation || "").trim() === "Checked Out";
  // Not this visit itself, another of the patient's appointments that day, or
  // one dated on/before the card's day (a patient seen before their slot had
  // their own appointment as "next").
  const nextAppt = followUpAppointment(data);

  // 'No Follow Up Appointment Scheduled' (request 2026-09-22): shown when the
  // visit is effectively over — checked out, a prior-day card, or sitting in
  // Ready for Checkout over an hour (ReadyForCheckoutTime journey stamp) —
  // and no future appointment is booked.
  // Stamps and "today" are clinic time (America/Chicago), not the browser's.
  const overHourAwaitingCheckout = (() => {
    if (String(data?.visit_confirmation || "").trim() !== "Ready for Checkout")
      return false;
    const t = parseStamp(parseJourney(data?.signintime).ReadyForCheckoutTime);
    return Boolean(t && minutesBetween(t, new Date()) >= 60);
  })();
  const isPastDay = isPastClinicDay(data?.startdate);
  const showNoFollowUp =
    !nextAppt && (isCheckedOut || isPastDay || overHourAwaitingCheckout);

  const cardOrders = (data.orders || []).filter((o) => !isCoverageNote(o));
  const { count: cardListedCount, allInactive: cardAllInactive } =
    orderBadge(cardOrders);
  const cardCoveredPlans = getCoveredPlans(data);
  // The day's coverage note(s), newest first, behind the "i" by the chips.
  // Sorted by the real save time (tasklog / a non-midnight ts), not the
  // visit-day key ts.
  const coverageNotes = (data.orders || [])
    .filter(isCoverageNote)
    .sort(compareCoverageNotes);

  // One-click checkout from the "Check out?" reminder. Same call as the Visit
  // Status modal's Update with "Checked Out" (the server also clears the room
  // and checks out the patient's other open appointments that day).
  // checkOutVisit is the call + local update, shared with "Mark done & check
  // out"; true when the visit was checked out. Callers own checkingOut.
  const checkOutVisit = async (successMessage = "Checked out") => {
    const practiseid = getPracticeId();
    const payload = {
      appointment_id: data?.appointmentid,
      appointment_date: dayjs(data?.startdate).format("YYYY-MM-DD"),
      visit_confirmation: "Checked Out",
    };
    if (data?.linked_provider) payload.linked_provider = data.linked_provider;
    try {
      const response = await api.put(
        `/v1/${practiseid}/checkin/patient/${data?.patientid}/update-data`,
        payload,
      );
      if (response?.status === 200) {
        // Mirror the server: status (also on the patient's other open
        // appointments that day, which the status chip reads), cleared room,
        // and the CheckedOutTime stamp (kept if the row already has one) so
        // the totals show at once.
        const terminal = ["Checked Out", "Cancelled", "Rescheduled", "No Show"];
        setFetchedData((prev) =>
          prev.map((item) => {
            if (item.id !== data.id) return item;
            let journey = item.signintime;
            if (typeof journey === "string") {
              try {
                journey = JSON.parse(journey);
              } catch {
                journey = null;
              }
            }
            // A stamp from another day (cloned row) is not this visit's.
            const signintime =
              journey &&
              typeof journey === "object" &&
              !isStampOnDay(journey.CheckedOutTime, item.startdate)
                ? { ...journey, CheckedOutTime: clinicStamp() }
                : item.signintime;
            return {
              ...item,
              visit_confirmation: "Checked Out",
              room_no: "",
              signintime,
              // Keep only a real follow-up (not this or a same-day visit),
              // or the Next Appointment pill shows the visit just closed.
              next_appointment: followUpAppointment(item)
                ? item.next_appointment
                : "",
              allappts: Array.isArray(item.allappts)
                ? item.allappts.map((a) =>
                    terminal.includes(a?.visit_confirmation)
                      ? a
                      : { ...a, visit_confirmation: "Checked Out" },
                  )
                : item.allappts,
            };
          }),
        );
        setToastMessage(successMessage);
        setToastSeverity("success");
        setOpenToast(true);
        return true;
      } else {
        setToastMessage(response?.message || "Could not check out. Please try again.");
        setToastSeverity("info");
        setOpenToast(true);
      }
    } catch (error) {
      console.error(error);
      setToastMessage("Something Went Wrong");
      setToastSeverity("error");
      setOpenToast(true);
    }
    return false;
  };
  const handleQuickCheckout = async () => {
    if (checkingOut) return;
    setCheckingOut(true);
    try {
      await checkOutVisit();
    } finally {
      setCheckingOut(false);
    }
  };

  // "Mark done & check out" on the "<order> pending · still here?" prompt
  // (owner option b, 09-29): the patient left with an in-clinic order never
  // marked done (chart 8823, PREVNAR 20). After the inline confirm, completes
  // the open orders with the dashboard's markAsComplete, the same call as the
  // Orders / Tasks quick view's "Mark as Complete" (PUT
  // /v1/{p}/tasks/{patientid}/mark_as_complete), then checks out with the
  // one-click "Check out" call above. A failed completion stops before the
  // checkout, so the card never shows Checked Out with the order still open.
  const handleMarkDoneAndCheckout = async (openOrders) => {
    if (checkingOut || typeof markAsComplete !== "function") return false;
    const orders = (Array.isArray(openOrders) ? openOrders : []).filter(
      (o) => o && o.id !== null && o.id !== undefined && o.id !== "",
    );
    if (!orders.length) return false;
    const names = orders
      .map((o) => String(o.ordername || o.ordertype || "order").replace(/<[^>]*>/g, "").trim())
      .join(", ");
    setCheckingOut(true);
    try {
      const res = await markAsComplete(
        orders.map((o) => String(o.id)),
        orders.map((o) => ({ ...o, patientid: o.patientid ?? data?.patientid })),
      );
      // The gateway answers 200 with no "data" when no order row matched
      // ("Task not found"): that is a failure too.
      const completed = res?.status === 200 && res?.data !== undefined;
      if (!completed) {
        setToastMessage(
          `Could not mark ${names} done, so the patient was not checked out.${
            res?.message ? ` ${res.message}` : ""
          }`,
        );
        setToastSeverity("error");
        setOpenToast(true);
        return false;
      }
      return await checkOutVisit(`Marked ${names} done and checked out`);
    } finally {
      setCheckingOut(false);
    }
  };
  const canQuickCheckout = homescreenprev.includes("Visit Confirmation");
  // Completing orders has no gate of its own on the card (anyone who sees the
  // Orders / Tasks box can); checking out needs Visit Confirmation.
  const canMarkDoneCheckout =
    canQuickCheckout && typeof markAsComplete === "function";

  return (
    <>
      <div
        className={`bmpc${
          latestAppointment?.visit_confirmation === "Cancelled"
            ? ` is-cancelled${dimCancelled ? " is-dimmed" : ""}`
            : qualityRisk
              ? " is-risk"
              : ""
        }`}
      >
        {/* A cancelled visit is marked by the red left accent alone (is-cancelled). */}
        {latestAppointment?.visit_confirmation !== "Cancelled" &&
        qualityRisk ? (
          <div className="bmpc-banner risk">
            Risk Adjustments and Quality Measure - Eligible
          </div>
        ) : null}

        <div className="left">
          <div className="identity">
            <div
              onClick={() => {
                if (homescreenprev.includes("P-Card")) {
                  fetchpcarddata(data.id, data);
                }
              }}
              className="cursor-pointer"
              title="Open P-Card"
              style={{
                border: `3.5px solid #${data.deductiblemet}`,
                borderRadius: "12px",
                lineHeight: 0,
                flex: "none",
              }}
            >
              <PatientAvatar
                row={data}
                name={`${data.firstname} ${data.lastname}`}
              />
            </div>

            <div className="pinfo">
              <h2>
                {/* Name opens the P-Card, same privilege gate as the photo. */}
                <span
                  className="cursor-pointer hover:underline"
                  title="Open P-Card"
                  onClick={() => {
                    if (homescreenprev.includes("P-Card")) {
                      fetchpcarddata(data.id, data);
                    }
                  }}
                >
                  {data.firstname + " " + data.lastname || "-"}
                </span>
                <span className="id">#{data.patientid || "-"}</span>
              </h2>

              <div className="demographics">
                DOB : {dayjs(dob || data.dob).format("MM/DD/YYYY") || "-"}
              </div>

              <div className="demographics insurance">
                {/* No insurance on file in Athena (owner 10-15): an amber chip in place of
                    the "-" - Athena will refuse the check-in (insuranceWarning.js). */}
                <NoInsuranceChip row={data}>
                  {data.insurancename?.length > 16
                    ? `${data.insurancename.slice(0, 16)}...`
                    : data.insurancename || "-"}
                </NoInsuranceChip>

                {finalformattedTotalcopay !== null &&
                  finalformattedTotalcopay !== undefined && (
                    // Coverage status picked in Payments (7825: Athena
                    // eligibility); Unverified until then.
                    <CoveragePill
                      row={data}
                      amount={finalformattedTotalcopay}
                      onClick={() => setIsPaymentModalOpen(true)}
                    />
                  )}
              </div>

              {qualityRisk !== null &&
                qualityRisk !== undefined && (
                  <button
                    className="due"
                    style={{
                      background: "#800080",
                      marginLeft: 0,
                      marginTop: "6px",
                    }}
                    onClick={() => setQuartersModalOpen(true)}
                  >
                    {qualityRisk}
                  </button>
                )}
            </div>

                  <div className="tag-col">
                    <div>
                      {!rpm ? (
                        <></>
                      ) : (
                        <div>
                          <div
                            onClick={() => {
                              navigate(`/rpm?pid=${data?.patientid}`);
                            }}
                            title={rpm.active && latestRpm ? undefined : rpm.title || undefined}
                            className={`${
                              rpm.active
                                ? "bg-[#e7f8ee] text-[#17a34a]"
                                : "bg-[#F2F4F7] text-[#667085]"
                            } text-[9px] font-semibold tracking-[0.02em] rounded-[4px] px-[6px] py-[3px] font-inter cursor-pointer flex items-center gap-1 whitespace-nowrap group`}
                          >
                            <RpmIcon
                              data={data}
                              latestRpm={rpm.active ? latestRpm : null}
                              color={rpm.active ? undefined : "#98A2B3"}
                            />
                            {rpm.label}
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      {" "}
                      {data?.fcmtoken ? (
                        <div className=" bg-[#e9f2fd] cursor-default flex items-center gap-1 font-inter text-[9px] font-semibold tracking-[0.02em] rounded-[4px] px-[6px] py-[3px] text-[#2f80ed]">
                          {mobileiconnew} APP
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

            {/* Post-checkout (request 2026-09-22): the room chip is a static
                "Checked Out" with no assign control, so a finished visit cannot
                be reopened from the card (assigning a room writes Ready for
                Provider). */}
            {latestAppointment?.visit_confirmation === "Cancelled" ? null : isCheckedOut ? (
              <div className="room" style={{ cursor: "default" }} title="Checked Out">
                <div className="room-head">
                  <span className="room-place">Checked Out</span>
                </div>
              </div>
            ) : (
              <div
                className="room"
                title={
                  homescreenprev.includes("Room Assignment")
                    ? "Assign Room"
                    : undefined
                }
                onClick={() => {
                  if (homescreenprev.includes("Room Assignment")) {
                    setRoomModalOpen(true);
                  }
                }}
              >
                <div className="room-head">
                  <span className="room-place">{roomLabel}</span>
                </div>
                <span className="plus" aria-hidden="true">
                  +
                </span>
              </div>
            )}
          </div>

          {/* Next appointment panel. Previously this only rendered for a
              checked-out patient and took the timeline's place; the reference
              shows it whenever the backend sent one. The timeline is still
              suppressed for a checked-out patient with a booked follow-up, as
              before. */}
          {nextAppt && (
            <div className="next-appt-row">
              <div className="next-appt">
                <span className="next-appt-icon">
                  {actionDropDownCalenderIcon}
                </span>
                <div className="next-appt-text">
                  <span className="next-appt-cap">Next Appointment</span>
                  <span className="next-appt-val">
                    {[
                      nextAppt.provider,
                      dayjs(nextAppt.startdate).format("MMM D, YYYY"),
                      nextAppt.starttime
                        ? dayjs(`2000-01-01 ${nextAppt.starttime}`).format(
                            "h:mm A",
                          )
                        : "",
                    ]
                      .filter(Boolean)
                      .join(" \u00b7 ")}
                  </span>
                </div>
              </div>
            </div>
          )}

          <div className="timeline-wrap">
          {/* Checked out with a follow-up booked: the steps give way to the
              Next Appointment panel above, but dev's chip row (visit totals,
              "Not checked out") still belongs under it. */}
          {isCheckedOut && nextAppt ? (
            <VisitTimeline data={data} showSteps={false} />
          ) : showNoFollowUp ? (
            <>
            <div style={{ display: "flex", justifyContent: "center", padding: "12px 0" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "#FFFBEB",
                  border: "1px solid #FDE68A",
                  borderRadius: "16px",
                  padding: "10px 20px",
                }}
              >
                <ErrorOutlineIcon style={{ fontSize: 18, color: "#B45309" }} />
                <span style={{ fontSize: "13px", fontWeight: 700, color: "#92400E" }}>
                  No Follow Up Appointment Scheduled
                </span>
              </div>
            </div>
            <VisitTimeline
              data={data}
              showSteps={false}
              showFollowUp={false}
              onCheckout={canQuickCheckout ? handleQuickCheckout : undefined}
              onMarkDoneCheckout={canMarkDoneCheckout ? handleMarkDoneAndCheckout : undefined}
              checkingOut={checkingOut}
            />
            </>
          ) : (
            /* The Next Appointment panel above already names the follow-up, so
               the timeline's own follow-up chip would say it twice. */
            <VisitTimeline
              data={data}
              showFollowUp={!nextAppt}
              onCheckout={canQuickCheckout ? handleQuickCheckout : undefined}
              onMarkDoneCheckout={canMarkDoneCheckout ? handleMarkDoneAndCheckout : undefined}
              checkingOut={checkingOut}
            />
          )}
          </div>

          <details className="notes" open>
            <summary>
              {/* Section heading shares the row with the chevron, styled as the
                  reference's .notes-h (11px/400, letter-spaced, grey) so it reads
                  as a label rather than competing with the row titles below. */}
              <span className="notes-h">Notes</span>
              <span
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span className="chevron">
                  <DisclosureChevron />
                </span>
              </span>
            </summary>
            <div className="notes-body">
                {(() => {
                  const noteItems = [];

                  // 1. Alert / Test(s) due notes
                  // if (data?.notes?.trim()) {
                  //   const cleaned = data.notes
                  //     .replace(/<br\s*\/?>/gi, "")
                  //     .trim();
                  //   const formatted =
                  //     cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
                  //   const isTestsDue = /^Test\(s\)\s*Due:/i.test(formatted);
                  //   const subtitle = isTestsDue
                  //     ? formatted.replace(/^Test\(s\)\s*Due:\s*/i, "")
                  //     : formatted;
                  //   noteItems.push({
                  //     id: "notes",
                  //     title: isTestsDue ? "Test(s) due" : "Notes",
                  //     badge: null,
                  //     subtitle,
                  //     titleColor: "#1D2951",
                  //     subtitleColor: "#1D2951",
                  //   });
                  // }

// Collect all notes from visible appointments
const allNotes = visibleAppts
  ?.filter((appt) => appt?.notes?.trim())
  ?.map((appt) => ({
    note: appt.notes.replace(/<br\s*\/?>/gi, "").trim(),
    starttime: appt.starttime,
  }));

// The grey section heading already says Notes, and this row rendered an empty
// bold "Notes" label whenever there were none, so it only carries the text now.
if (allNotes?.length) {
  noteItems.push({
    id: "notes",
    title: null,
    subtitle: allNotes,
    titleColor: "#1D2951",
    subtitleColor: "#1D2951",
  });
}

                  // Covered services render as chips beside the appointment
                  // row, so the notes list no longer repeats them.

                  // 3. Cost estimate
                  if (costEstimate > 0 && getPatientColor() !== "green") {
                    noteItems.push({
                      id: "cost",
                      title: "Cost Estimate",
                      badge: null,
                      subtitle: `$${costEstimate}`,
                      titleColor: "#111827",
                      subtitleColor: "#374151",
                    });
                  }

                  // 4. Payment warning: no payment colour set yet. A card
                  // block (7825 has none: it never colours visits, and its
                  // Payments popup has no colour controls to clear it with).
                  if (
                    cardBlockShown("paymentWarning") &&
                    latestAppointment?.visit_confirmation !== "Cancelled" &&
                    // "0" (Clear) or an unknown code is no pick either.
                    !isCoverageVerified(data?.deductiblemet)
                  ) {
                    noteItems.push({
                      id: "payment",
                      title: "Payment",
                      badge: null,
                      subtitle: "Not updated - Contact Gowtham",
                      titleColor: "#1D2951",
                      subtitleColor: "#1D2951",
                    });
                  }

                  if (noteItems.length === 0) return null;

                  const visibleItems = showMore
                    ? noteItems
                    : noteItems.slice(0, 2);
                  const hasMore = noteItems.length > 2;

                  return (
                    <>
                      <div
                        className={showMore ? "overflow-y-auto pr-1" : ""}
                        style={
                          showMore
                            ? {
                                maxHeight: "calc(3 * 52px)",
                                scrollbarWidth: "thin",
                              }
                            : {}
                        }
                      >
                        <div className="flex flex-col gap-2">
                          {visibleItems.map((item) => (
                            <div key={item.id} className="note-row">
                              <div>
                                <div className="note-head">
                                  <span className="note-icon" aria-hidden="true">
                                    {alertIcon}
                                  </span>
                                  {item.title && (
                                    <span
                                      className="note-title"
                                      style={{ color: item.titleColor }}
                                    >
                                      {item.title}
                                    </span>
                                  )}
                                  {item.badge != null && (
                                    <span className="note-badge">
                                      {item.badge}
                                    </span>
                                  )}
                                </div>
                                {/* <p
                                  className="text-[11px] font-inter font-normal mt-0.5 leading-tight"
                                  style={{ color: item.subtitleColor }}
                                >
                                  {item.subtitle}
                                </p> */}
{Array.isArray(item.subtitle) ? (
  item.subtitle.map((entry, idx) => (
    <p
      key={idx}
      className="note-sub"
      style={{ color: item.subtitleColor }}
    >
      • {entry.note}
      {item.subtitle.length > 1 && entry.starttime
        ? ` - ${formatTime(entry.starttime)}`
        : ""}
    </p>
  ))
) : (
  <p className="note-sub" style={{ color: item.subtitleColor }}>
    {item.subtitle}
  </p>
)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      {hasMore && (
                        <button
                          onClick={() => setShowMore(!showMore)}
                          className="absolute bottom-1 right-2 text-[12px] font-inter"
                          style={{ color: "#50869A" }}
                        >
                          {showMore ? "Show less" : "Show more"}
                        </button>
                      )}
                    </>
                  );
                })()}
            </div>
          </details>

          <QualityRiskApptsModal
            open={quartersModalOpen}
            onClose={() => setQuartersModalOpen(false)}
            patientid={data?.patientid}
            initialDates={data?.quality_risk_appts}
            setToastMessage={setToastMessage}
            setToastSeverity={setToastSeverity}
            setOpenToast={setOpenToast}
            refreshDashboard={refreshDashboard}
          />
        </div>

        <div className="right">
          <div className="appointment">
            {/* allappts only carries patientid/purpose/encounterid (the dashboard
                query selects just those three), so read the row itself for time
                and provider and keep allappts as the fallback. */}
            <span className="time">
              {formatTime(data?.starttime || latestAppointment?.starttime) ||
                "-"}
            </span>

            <button
              className="visit-type"
              title="Update Type of Visit"
              onClick={(e) => {
                e.stopPropagation();
                setPurposeInitialIndex(0);
                setPurposeModalOpen(true);
              }}
            >
              <span className="truncate text-[#1E3A8A] inter">
                {data?.purpose || "-"}
              </span>

              {visibleAppts?.slice(1)?.map((appt) => (
                <span
                  key={appt?.appointmentid ?? appt?.id ?? appt?.starttime}
                  title={appt?.purpose}
                  className="text-[#1E3A8A] truncate"
                >
                  , {appt?.purpose}
                </span>
              ))}

              {remainingCount > 0 && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenAllApptsModal(true);
                  }}
                  className="bg-[#EEF2FF] px-2 py-[2px] ml-1 rounded-[10px] text-[#1D4ED8] font-inter text-[11px] font-medium cursor-pointer"
                >
                  +{remainingCount} more
                </span>
              )}
            </button>

            <span
              className="provider-value"
              title="Update Provider"
              onClick={() => {
                if (homescreenprev.includes("Change Provider")) {
                  setProviderModalOpen(true);
                }
              }}
            >
              {bluesethescope}{" "}
              {data?.linked_provider || latestAppointment?.linked_provider || "-"}
            </span>
            {/* Visit status, at the end of the time / visit type / provider row
                (request 2026-10-01). It is the card's only way into the Visit
                Status modal, so it also renders for a blank status (walk-ins,
                not-yet-arrived) - "Visit Status" - but only for users who can
                change it (10379, 2026-09-29). */}
            {(latestAppointment?.visit_confirmation || homescreenprev.includes("Visit Confirmation")) && (
            <span className="appt-status">
              {latestAppointment?.visit_confirmation ? (
                <button
                  onClick={() => {
                    if (homescreenprev.includes("Visit Confirmation")) {
                      setVisitModalOpen(true);
                    }
                  }}
                  className={
                    "px-3 py-[2px] font-inter font-medium rounded-[10px] text-[12px] border-[1px] focus:outline-none " +
                    statusChipClasses(
                      latestAppointment?.visit_confirmation,
                      Boolean(latestAppointment?.visit_confirmation),
                    )
                  }
                  title="Update Visit Status"
                >
                  {latestAppointment?.visit_confirmation}
                </button>
              ) : (
                <button
                  onClick={() => {
                    if (homescreenprev.includes("Visit Confirmation")) {
                      setVisitModalOpen(true);
                    }
                  }}
                  title="Update Visit Status"
                  className="px-3 py-[2px] font-inter font-medium rounded-[10px] text-[12px] border-[1px] border-[#ECECEE] text-[#1D4ED8] bg-white focus:outline-none"
                >
                  Visit Status
                </button>
              )}
            </span>
            )}
            {/* Athena check-in refused / failed / blocked: never retried automatically - staff act on it
                (refused / failed: one check-in attempt per click, Visit Confirmation privilege). */}
            <AthenaCheckinChip
              row={data}
              className="ml-2"
              canCheckIn={homescreenprev.includes("Visit Confirmation")}
            />
          </div>

          {/* Coverage sits in the right column under the time / visit type /
              provider row (request 2026-10-01). Every covered service renders
              identically, so LABS and ULTRASOUND look like the rest. */}
          {/* Only patients with at least one covered service get the section;
              the coverage-note "i" lives inside it. */}
          {cardCoveredPlans.length > 0 ? (
            <div className="coverage">
              <div className="coverage-head">
                <span className="coverage-cap">Coverage</span>
                {cardCoveredPlans.length > 0 && (
                  <span className="coverage-summary">
                    All {cardCoveredPlans.length} covered
                  </span>
                )}
              </div>
              <div
                className="coverage-chips"
                role="group"
                aria-label="Covered services"
              >
                {cardCoveredPlans.map((plan) => (
                  <span
                    key={plan}
                    className="coverage-chip"
                    title={`${coverageLabel(plan)} - covered`}
                  >
                    <svg
                      className="coverage-tick"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <polyline
                        points="4 12.5 9.5 18 20 6"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {coverageLabel(plan)}
                  </span>
                ))}
                {coverageNotes.length > 0 && (
                  <button
                    type="button"
                    className="coverage-info"
                    title="Coverage note"
                    aria-label="Show the coverage note"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCoverageModalOpen(true);
                    }}
                  >
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9.5" fill="none" stroke="currentColor" strokeWidth="2" />
                      <path d="M12 11v6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                      <circle cx="12" cy="7.6" r="1.3" fill="currentColor" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          ) : null}

          {cardOrderNotes() && (
            <OrderNotes data={data} setFetchedData={setFetchedData} setToastMessage={setToastMessage}
              setToastSeverity={setToastSeverity} setOpenToast={setOpenToast} />
          )}
          {/* hubfix-oi-1026: orders heard in this patient's recorded visit today, one tap each (9928, enabled
              providers; the chart's card, model and guards). Clicks stay inside the card. */}
          <div onClick={(e) => e.stopPropagation()} role="presentation">
            <LiveOrdersSlot patientId={data.patientid} chart={data} surface="dashboard" />
          </div>
          {/* Orders / Tasks: gated per practice (7825: order notes above instead) */}
          {cardBlockShown("orders") && (
          <details className="orders" open>
            <summary>
              Orders/Tasks
              <span
                className={`count${cardListedCount > 0 && !cardAllInactive ? "" : " zero"}`}
              >
                {cardListedCount}
              </span>
            </summary>
            {/* Collapsed shows the first rows under a fade; the reference uses a
                show-all toggle rather than an inner scrollbar. */}
            <div className={`task-scroll${ordersExpanded ? " open" : ""}`}>
              <CardBox data={data} paymentdetails={paymentdetails} hideHeader />
            </div>
            {cardListedCount > 2 && (
              <button
                type="button"
                className="orders-toggle"
                aria-expanded={ordersExpanded}
                onClick={() => setOrdersExpanded((v) => !v)}
              >
                {ordersExpanded ? "Show less" : "Show all orders"}
                <span className="orders-toggle-chevron" aria-hidden="true">
                  <DisclosureChevron />
                </span>
              </button>
            )}
          </details>
          )}
        </div>

        <div className="actions">
          {pinnedActions.map((action) => (
            <div key={action.id} className="relative group">
              <button
                onClick={action.onClick}
                className={`act${
                  (action.key === "Notes" && noteModalOpen) ||
                  (action.key === "Take Payment" && isPaymentModalOpen)
                    ? " on"
                    : ""
                }`}
              >
                {action.icon}
              </button>
              {/* Opens leftward: the rail is the card's right edge, so a tooltip
                  on the right runs off the viewport. */}
              <span className="absolute right-[60px] top-1/2 -translate-y-1/2 bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap shadow-md z-10">
                {action.label}
              </span>
            </div>
          ))}

          {/* Dropdown for remaining actions */}
          {homescreenprev.includes("Actions") && (
            // Same plain wrapper as the pinned buttons so all six share one
            // column and size (the old centered 56px box overflowed the rail).
            <div className="relative">
              <DropdownMenu
                rail
                homescreenprev={homescreenprev}
                insertdata={insertdata}
                viewMode={viewMode}
                isSameDate={isSameDate}
                data={data}
                setToastSeverity={setToastSeverity}
                setToastMessage={setToastMessage}
                setOpenToast={setOpenToast}
                modalopen={modalopen}
                openPaymentModal={openPaymentModal}
                openNoteModal={openNoteModal}
                isOpen={isOpen}
                searchTerm={searchTerm}
                setIsOpen={setIsOpen}
                setSelectedCard={setSelectedCard}
                setChat={setChat}
                loc={"exp"}
                handleschedular={handleschedular}
              />
            </div>
          )}
        </div>

        {isPaymentModalOpen && (
          <Paymentsmodal
            alldata={alldata}
            setFetchedData={setFetchedData}
            data={data}
            fetchedData={alldata}
            costEstimate={costEstimate}
            closePaymentModal={closePaymentModal}
          />
        )}
      </div>
      {VisitStatus && (
        <VisitStatusUpdate
          selectedAppointment={data}
          closeAllModals={closeVisitStatus}
        />
      )}
      {visitModalOpen ? (
        <VisitStatusModal
          open={visitModalOpen}
          current={data?.visit_confirmation || latestAppointment?.visit_confirmation || ""}
          onClose={() => setVisitModalOpen(false)}
          selectedCard={data}
          setFetchedData={setFetchedData}
          setVisitModalOpen={setVisitModalOpen}
        />
      ) : (
        <></>
      )}

      {coverageModalOpen && (
        <CoverageNoteModal
          open={coverageModalOpen}
          onClose={() => setCoverageModalOpen(false)}
          notes={coverageNotes}
        />
      )}

      {roomModalOpen ? (
        <AssignRoomModal
          setRoomModalOpen={setRoomModalOpen}
          setFetchedData={setFetchedData}
          open={roomModalOpen}
          currentRoom={data.room_no || ""}
          onClose={() => setRoomModalOpen(false)}
          selectedCard={data}
          alldata={alldata}
        />
      ) : (
        <></>
      )}

      {purposeModalOpen && (
        <PurposeOfVisitModal
          open={purposeModalOpen}
          setFetchedData={setFetchedData}
          setPurposeModalOpen={setPurposeModalOpen}
          onClose={() => setPurposeModalOpen(false)}
          selectedCard={data}
          appointments={allAppts}
          formatTime={formatTime}
          initialIndex={purposeInitialIndex}
        />
      )}

      {noteModalOpen && (
        <AddNotesModal
          open={noteModalOpen}
          defaultAssignee={noteDraft.assignee}
          defaultMessage={noteDraft.message}
          setNoteModalOpen={setNoteModalOpen}
          setFetchedData={setFetchedData}
          selectedCard={data}
          refreshDashboard={refreshDashboard}
        />
      )}

      {providerModalOpen && (
        <ProviderModal
          open={providerModalOpen}
          current={localProvider}
          onClose={() => setProviderModalOpen(false)}
          selectedCard={data}
          setFetchedData={setFetchedData}
          setProviderModalOpen={setProviderModalOpen}
        />
      )}
      <AllAppointmentsModal
        statusChipClasses={statusChipClasses}
        open={openAllApptsModal}
        onClose={() => setOpenAllApptsModal(false)}
        appointments={data.allappts}
        formatTime={formatTime}
        onEditPurpose={(index) => {
          setPurposeInitialIndex(index || 0);
          setOpenAllApptsModal(false);
          setPurposeModalOpen(true);
        }}
      />
      {frontdeskModal && (
        <ConfirmFrontdesk
          frontDesk={frontDesk}
          handleFrontDeskToggle={handleFrontDeskToggle}
          setfrontdeskModal={setfrontdeskModal}
        />
      )}
      {isQuickOpen && (
        <TasksModal
          setFetchedData={setFetchedData}
          setToastSeverity={setToastSeverity}
          setToastMessage={setToastMessage}
          setOpenToast={setOpenToast}
          handleconfirmScheduleClick={handleconfirmScheduleClick}
          scheduleStates={scheduleStates}
          closetaskModal={() => {
            setIsQuickOpen(false);
          }}
          handleScheduleClick={handleScheduleClick}
          task={totalOrders}
          markAsComplete={markAsComplete}
          markAscancel={markAscancel}
          data={data}
          // fetchDashboardData={fetchDashboardData}
        />
      )}
      {sendFormsWizard}
      {staffFormFill}
    </>
  );
};

export default ExpandedView;
